<template>
    <footer class="home-footer-wrapper">
        <div>
            <span>&#169; {{this.year}} Complex Shipbuilding Services AS {{ $t('Footer.span1') }}</span>
            <span>{{$t('Footer.span2')}} <a target="_blank" href="https://dipit.dev">dip it - a web development company</a></span>
        </div>
        <div>
            <router-link style="text-decoration:none;" :to="`/${$i18n.locale}/terms-of-service`">
                <span><a href="">{{ $t('Footer.span3') }}</a></span>
            </router-link>
            <router-link style="text-decoration:none;" :to="`/${$i18n.locale}/privacy-policy`">
                <span><a href="">{{ $t('Footer.span4') }}</a></span>
            </router-link>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'footer-home',
    data () {
        return {
            year: new Date().getFullYear(),
        }
    }
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.home-footer-wrapper {
    height: 100px;
    background-color: #10424b;
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px 0 100px;
    @include mobileBig {
        padding: 0 50px 0 50px;   
    }
    @include mobile {
        padding: 0 10px 0 10px;
    }
    div {
        display: flex;
        flex-direction: column;
        text-align: left;
        span {
            @include mobile {
                text-align: left;
                font-size: 14px;
                margin: 10px;
            }
            a {
                color: white;
                text-decoration: none;
            }
        }
        &:nth-child(2) {
            flex-direction: row;
            @include mobile {
                flex-direction: column;
            }
            span {
                width: auto;
                margin: 0 0 0 20px;
                text-align: center;
                @include mobile {
                    text-align: center;
                    margin: 10px;
                    font-size: 14px;
                }
                a {
                    padding: 20px 0 20px 0;
                    @include mobile {
                        padding: 5px 0 5px 0;
                    }
                }
            }
        }
    }
}
</style>